/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { LocationResource } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface LocationServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Location check title deed
     * 
     * @param cadastralTerritory 
     * @param titleDeedNumber 
     */
    checkTitleDeed(cadastralTerritory: number, titleDeedNumber: number, extraHttpRequestParams?: any): Observable<LocationResource>;

}
